import { instance as axios } from "@/store/_AXIOS"
import { _TOKEN, _DECODE } from "@/store/_JWT"

const TABLE = "/session/"

// initial state
const state = {
  session: false,
  user: null,
  instituicao: -1
}

// getters
const getters = {
  getState: function(state) {
    return state
  }
}

// actions
const actions = {
  getData({ commit, dispatch }, params) {
    return axios
      .post(TABLE + "get/" + _TOKEN(params))
      .then(res => {
        if (res.data.results == 1) {
          return _DECODE(res.data.data).then(r => {
            if (r) {
              commit("setSessionData", r[0])
              dispatch("setInstituicoes", r[0].instituicoes)
              return true
            } else {
              commit("setSessionData", null)
              return false
            }
          })
        } else {
          commit("setSessionData", null)
          return false
        }
      })
      .catch(err => {
        commit("setSessionData", null)
        return false
      })
  },

  signIn({ commit, dispatch }, params) {
    return axios
      .post(TABLE + "login/" + _TOKEN(params))
      .then(res => {
        if (res.data.results == 1) {
          return _DECODE(res.data.data).then(r => {
            if (r) {
              commit("setSessionData", r[0])
              dispatch("setInstituicoes", r[0].instituicoes)
              return true
            } else {
              commit("setSessionData", null)
              return false
            }
          })
        } else {
          commit("setSessionData", null)
          return false
        }
      })
      .catch(err => {
        commit("setSessionData", null)
        return false
      })
  },

  update({ dispatch }, params) {
    return axios
      .put(TABLE + _TOKEN(params))
      .then(res => {
        return !res.data.errors
      })
      .catch(err => {
        return false
      })
  },

  setSessionData({ commit }, data) {
    return commit("setSessionData", data)
  },

  setInstituicoes({ rootState }, instituicoes) {
    rootState.instituicao.data = instituicoes ? instituicoes : []
  }
}

// mutations
const mutations = {
  setSessionData(state, data) {
    if (data) {
      state.user = data
      state.instituicao = data.instituicoes[0].id_instituicao

      state.session = true
    } else state.session = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
